// extracted by mini-css-extract-plugin
module.exports = {"button":"_3NdOD","wrapper":"_1E8wV","label":"eQfqJ","bubble":"_35YDS"};